import { render, staticRenderFns } from "./rankingItem.vue?vue&type=template&id=8026c6e8&scoped=true&"
import script from "./rankingItem.vue?vue&type=script&lang=js&"
export * from "./rankingItem.vue?vue&type=script&lang=js&"
import style0 from "./rankingItem.vue?vue&type=style&index=0&id=8026c6e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8026c6e8",
  null
  
)

export default component.exports